import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';

const useStyles = makeStyles((theme) => ({
  alert: {
    marginBottom: theme.spacing(2),
    backgroundColor: '#C70805',
    borderRadius: 0,
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0, 1),
    },
    '& .MuiAlert-icon': {
      display: 'none',
      [theme.breakpoints.up('sm')]: {
        display: 'flex',
        alignItems: 'center',
        marginRight: theme.spacing(2),
      },
    },
  },
  title: {
    display: 'block',
    marginBottom: theme.spacing(0.5),
    fontSize: theme.typography.pxToRem(14),
    lineHeight: theme.typography.pxToRem(20),
    [theme.breakpoints.up('sm')]: {
      display: 'inline-block',
    },
  },
  window: {
    display: 'block',
    marginBottom: theme.spacing(0.5),
    fontSize: theme.typography.pxToRem(14),
    lineHeight: theme.typography.pxToRem(20),
    [theme.breakpoints.up('sm')]: {
      display: 'inline-block',
    },
  },
  message: {
    fontSize: theme.typography.pxToRem(12),
    lineHeight: theme.typography.pxToRem(18),
  },
}));

const MaintenanceAlert: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const IS_MAINTENANCE_ALERT_ON = process.env.REACT_APP_MAINTENANCE_ALERT === 'on';

  return IS_MAINTENANCE_ALERT_ON ? (
    <Alert
      variant="filled"
      severity="warning"
      icon={<ReportProblemIcon />}
      className={classes.alert}
    >
      <div>
        <b className={classes.title}>{t('scheduled_maintenance.title')}</b>{' '}
        <span className={classes.window}>{t('scheduled_maintenance.window')}</span>
      </div>
      <div className={classes.message}>{t('scheduled_maintenance.message')}</div>
    </Alert>
  ) : null;
};

export default MaintenanceAlert;
